import { EventLanguage } from 'generated/graphql'

// This config refer from http://www.lingoes.net/en/translator/langcode.htm
const languageConfigs = {
    en: EventLanguage.English,
    'en-US': EventLanguage.English,
    nl: EventLanguage.Dutch,
    'nl-BE': EventLanguage.Dutch,
    'nl-NL': EventLanguage.Dutch,
    de: EventLanguage.German,
    'de-AT': EventLanguage.German,
    'de-CH': EventLanguage.German,
    'de-DE': EventLanguage.German,
    'de-LI': EventLanguage.German,
    'de-LU': EventLanguage.German,
}

export const getDefaultLanguage = (): EventLanguage => {
    const browserLanguage = navigator.language
    return languageConfigs[browserLanguage] || languageConfigs.en
}
